//Our Modules

import SendWa from "./modules/SendWa";
import ResizeTopBar from "./modules/ResizeTopBar";
import LoginAccountWooCommerce from "./modules/LoginAccountWoocommerce";


//Instantiate our module
let navbar = document.getElementById('navbar');
if (navbar != null){
    const resizeTopBar = new ResizeTopBar()
}

if (window.location.pathname === "/inquiry/") {
    const sendWa = new SendWa();
}

if (window.location.pathname === "/akun/") {
    const loginAccount = new LoginAccountWooCommerce();
}

console.log(" bbb");